import React, { AnchorHTMLAttributes, DetailedHTMLProps } from 'react'
import { ReactComponent as ExternalIcon } from '@/assets/icons/arrow-up-right-from-square-regular.svg'
import classes from './Link.module.scss'

export type LinkProps = DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> & {
  isExternal?: boolean
}

const Link = ({ isExternal, children, ...props }: LinkProps) => {
  const target = isExternal ? '_blank' : props.target

  return (
    <a className={classes.root} {...props} target={target}>
      {children} {isExternal && <ExternalIcon />}
    </a>
  )
}

export default Link
